import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTimeCycleLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M10.695 2.086a10 10 0 0 1 8.314 2.781A1 1 0 0 1 21 5v2.5a1 1 0 0 1-1 1h-2.5a1 1 0 1 1 0-2h.31a8 8 0 0 0-3.74-2.227A8 8 0 0 0 8 5.072 1 1 0 1 1 7 3.34a10 10 0 0 1 3.695-1.254M12 6a1 1 0 0 1 1 1v5.586l1.828 1.828a1 1 0 0 1-1.414 1.414l-2.121-2.12A1 1 0 0 1 11 13V7a1 1 0 0 1 1-1m-8.397.456a1 1 0 0 1 1.366.366l.09.157.024.04 1.136 1.968a1 1 0 1 1-1.732 1l-.155-.268A8 8 0 0 0 8 18.929a1 1 0 0 1-1 1.731A10 10 0 0 1 2.318 9.497a1 1 0 0 1-.88-1.791zM21 11a1 1 0 0 1 1 1 10 10 0 0 1-7.327 9.636 1 1 0 0 1-1.11 1.658l-2.166-1.25a1 1 0 0 1-.366-1.366l.093-.16q.009-.018.02-.034l1.137-1.97a1 1 0 0 1 1.732 1l-.155.267a8 8 0 0 0 3.799-2.124A8 8 0 0 0 20 12a1 1 0 0 1 1-1'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTimeCycleLine)
export default ForwardRef
